import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, Stack, Typography } from "@mui/material";
import { MprcButton } from "components";
import { MprcStringToHtml } from "components/MprcStringToHtml";
import { MprcText } from "components/MprcText";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";

interface ConfirmOptions {
    value: string;
    label: string;
}

interface IProps {
    title?: React.ReactNode;
    message?: React.ReactNode;
    cancelText?: string;
    onClose: (result?: ConfirmOptions | null) => void;
    options: ConfirmOptions[];
    severity?: "none" | "danger" | "question";
}

type DialogPropsType = Omit<DialogProps, "onClose">;

export const DevPlanConfirmEnrollmentDialog: React.FC<IProps & DialogPropsType> = (props) => {
    const { severity = "question", title, onClose, options, cancelText, ...dialogProps } = props;

    const { theme } = useMprcTheme();
    const lMessage = props.message || theme.MprcConfirmDialog.message;

    return (
        <Dialog
            onClose={() => onClose(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={dialogProps.maxWidth ?? "sm"}
            fullWidth
            {...dialogProps}
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>

            <DialogContent>
                <Box id="alert-dialog-description">
                    <Grid container justifyContent="center" spacing={2}>
                        {
                            !title && severity != "none" &&
                            <Grid alignSelf="flex-start">
                                <MprcText color={(severity == "question" ? "warning" : "error")}>
                                    <FontAwesomeIcon icon={severity == "question" ? faQuestionCircle : faTriangleExclamation} size="3x" />
                                </MprcText>
                            </Grid>
                        }
                        <Grid size="grow" alignSelf="center">
                            <Typography variant="body2" color="black" component="div">
                                {
                                    typeof (lMessage) == "string" || Array.isArray(lMessage)
                                        ? <MprcStringToHtml text={lMessage} splitChar={'\n'} separator={<br />} />
                                        : lMessage
                                }
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center" }}>
                <Stack direction="column" spacing={2} width="100%">
                    {
                        options.map((option, index) => (
                            <MprcButton key={index}
                                color="primary"
                                variant="contained"
                                fullWidth
                                onClick={() => onClose(option)}
                            >
                                {option.label}
                            </MprcButton>
                        ))
                    }
                    <MprcButton autoFocus
                        color={"error"}
                        variant="contained"
                        fullWidth
                        onClick={() => onClose(null)}
                    >
                        {cancelText || theme.MprcConfirmDialog.noText || "Cancel"}
                    </MprcButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
